import React, { createContext, useContext } from 'react'

export type MessagesServerSideSelectionContextValue = {
  totalCount: number
  selectedCount: number
  selectingAll: boolean
  listLoading: boolean
  onSelectAllMatching: () => void
  onClearSelection: () => void
}

const MessagesServerSideSelectionContext = createContext<MessagesServerSideSelectionContextValue | null>(null)

export const MessagesServerSideSelectionProvider = MessagesServerSideSelectionContext.Provider

export const useMessagesServerSideSelectionContext = () => {
  const value = useContext(MessagesServerSideSelectionContext)
  if (!value) {
    throw new Error('useMessagesServerSideSelectionContext requires MessagesServerSideSelectionProvider')
  }
  return value
}
